import Vue from 'vue'
import Vuex from 'vuex'
// vuex可持续化存储
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  isPhone: true,
  currentCom: 'index',
  m: 1, // 当前菜单id
  e: 0,
  vrSrc: '',
  isShowModal: false,
  isLoading: false,
  isHorizontal: true // 当前手机是否为横屏状态
}

const mutations = {
  setIsPhone(state, isPhone) {
    state.isPhone = isPhone
  },

  setCurrentCom(state, component) {
    state.currentCom = component
  },

  setMenu(state, m) {
    state.m = m
  },

  setExhibits(state, e) {
    state.e = e
  },

  setVrSrc(state, src) {
    state.vrSrc = src
  },

  setIsShowModal(state, bool) {
    state.isShowModal = bool
  },

  setLoadingStatus(state, status) {
    state.isLoading = status
  },

  setPhoneScreenType(state, isHorizontal) {
    state.isHorizontal = isHorizontal
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  plugins: [createPersistedState({ storage: window.sessionStorage })]
})

export default store
